/**
 * Composite formatter for the legacy "Zone X / Override Y / Store Z"
 * display used across the scan, promo-price, and allowance grids.
 * Legacy `Item/ViewItem.aspx` builds this string client-side from the
 * ZN_NO / OVRD_NO / STR_NO triple — see audit 14-parity-matrix.md §5
 * item 33.
 *
 * Rules (matching legacy):
 *   - Zone is always present (NOT NULL in DEAL_ITEM_SCAN / DEAL_ITEM_PROMO_PRICE).
 *   - Override is included only when non-null.
 *   - Store is included only when non-null.
 *   - Sections are separated by " / " (space-slash-space).
 *
 * Examples:
 *   { zone: 1 }                          → "Zone 1"
 *   { zone: 1, store: 1234 }             → "Zone 1 / Store 1234"
 *   { zone: 1, override: 5 }             → "Zone 1 / Override 5"
 *   { zone: 1, override: 5, store: 1234} → "Zone 1 / Override 5 / Store 1234"
 */
export const formatZoneOverrideStore = (input: {
  zone: number | null | undefined;
  override?: number | null;
  store?: number | null;
}): string => {
  const parts: string[] = [];
  if (input.zone != null) parts.push(`Zone ${input.zone}`);
  if (input.override != null) parts.push(`Override ${input.override}`);
  if (input.store != null) parts.push(`Store ${input.store}`);
  return parts.join(" / ");
};

/**
 * Same as {@link formatZoneOverrideStore} but accepts the cost-zone
 * variant used by DEAL_ITEM_ALLOWANCE (CST_ZONE_NO / STR_NO — no
 * override column on that table).
 */
export const formatCostZoneStore = (input: {
  costZone: number | null | undefined;
  store?: number | null;
}): string => {
  const parts: string[] = [];
  if (input.costZone != null) parts.push(`Zone ${input.costZone}`);
  if (input.store != null) parts.push(`Store ${input.store}`);
  return parts.join(" / ");
};
